// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"724f9d88","453":"1c402fba","455":"f5c70397"}[chunkId] + ".chunk.js";
};